import { type Tab, Tabs } from "~/components/reusable/Tabs"

import { CreatePurchaseOrder } from "./CreatePurchaseOrder"
import EditPurchaseOrder from "./EditPurchaseOrder"
import { type IVariantSummary } from "~/hooks/useVariantTableData"

export function PurchaseOrderTabs({
  variants,
  onEdit,
  onCancel,
  vendors,
  preSelectedVendorId,
  preSelectedWarehouseId,
  start,
  end,
  collectionIds,
  nameContext,
}: {
  variants: IVariantSummary[]
  onEdit: () => void
  onCancel: () => void
  vendors: { id: string; name: string }[]
  preSelectedVendorId?: string
  preSelectedWarehouseId?: string
  start?: Date
  end?: Date
  collectionIds?: string[]
  nameContext?: string
}) {
  const tabs: Tab[] = [
    {
      isDefault: true,
      label: "Create",
      content: (
        <CreatePurchaseOrder
          variants={variants}
          selectableVendors={vendors}
          preSelectedVendorId={preSelectedVendorId}
          preSelectedWarehouseId={preSelectedWarehouseId}
          start={start}
          end={end}
          onCancel={onCancel}
          collectionIds={collectionIds}
          nameContext={nameContext}
        />
      ),
    },
    {
      label: "Add to existing draft",
      content: (
        <EditPurchaseOrder
          variants={variants}
          onEdit={onEdit}
          onCancel={onCancel}
          selectableVendors={vendors}
          preSelectedVendorId={preSelectedVendorId}
        />
      ),
    },
  ]

  return <Tabs tabs={tabs} tabsListClassName="w-full" />
}
